import { render, staticRenderFns } from "./ListBlock.vue?vue&type=template&id=6ff045b4&"
import script from "./ListBlock.vue?vue&type=script&lang=js&"
export * from "./ListBlock.vue?vue&type=script&lang=js&"
import style0 from "./ListBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports